export type SessionStorageValues = {
  onboard_increase_error_message: string;
  onboard_stripe_error_message: string;
};

type Key = keyof SessionStorageValues;

/**
 * Gets a typed value from session storage.
 * @param key The key to lookup
 * @returns The value stored at that key, or null if there is none (or it is not valid JSON)
 */
export const getSessionStorage = <T extends Key>(
  key: T
): SessionStorageValues[T] | null => {
  const stringValue = window.sessionStorage.getItem(key);
  if (stringValue === null) {
    return null;
  }
  try {
    const value: SessionStorageValues[T] | null = JSON.parse(stringValue);
    return value;
  } catch (e: unknown) {
    return null;
  }
};

/**
 * Sets a value in session storage.
 * @param key The key to set
 * @param value The value to set at that key
 */
export const setSessionStorage = <T extends Key>(
  key: T,
  value: SessionStorageValues[T]
) => {
  window.sessionStorage.setItem(key, JSON.stringify(value));
};

export const removeSessionStorage = <T extends Key>(key: T) =>
  window.sessionStorage.removeItem(key);
